import { render, staticRenderFns } from "./ChangePlace.vue?vue&type=template&id=1d8b3e2e&"
import script from "./ChangePlace.vue?vue&type=script&lang=js&"
export * from "./ChangePlace.vue?vue&type=script&lang=js&"
import style0 from "./ChangePlace.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports